import { render, staticRenderFns } from "./RegisterRight.vue?vue&type=template&id=510ed23b&scoped=true&"
import script from "./RegisterRight.vue?vue&type=script&lang=js&"
export * from "./RegisterRight.vue?vue&type=script&lang=js&"
import style0 from "./RegisterRight.vue?vue&type=style&index=0&id=510ed23b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510ed23b",
  null
  
)

export default component.exports